// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Opening Hours`
};

const el_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Ωράριο Λειτουργίας`
};

const ru_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Часы работы`
};

const he_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `שעות פתיחה`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const opening_hours = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.opening_hours(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("opening_hours", locale)
	if (locale === "en") return en_opening_hours(inputs)
	if (locale === "el") return el_opening_hours(inputs)
	if (locale === "ru") return ru_opening_hours(inputs)
	if (locale === "he") return he_opening_hours(inputs)
	return "opening_hours"
};